/* Pumpkin seed oil page: ad-level tracking for visitors who arrive from Meta ads.
   - Reads the ad info from the link (utm_* and Meta's dynamic ad_id/adset_id/campaign_id, fbclid)
     and remembers it for 7 days, so a visitor who comes back later is still tied to her ad.
   - Only Meta visitors are tracked. Everyone else is ignored.
   - Events go to Klaviyo (for day-by-day reports per ad) and to the Meta pixel as custom events.
   - window.psoAttribution() returns the ad info so the Checkout button can save it on the order. */
(function () {
  'use strict';

  var script = document.currentScript;
  var company = script && script.getAttribute('data-company');
  var AD_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
    'campaign_id', 'adset_id', 'ad_id', 'placement', 'fbclid'];
  var STORE_KEY = 'psoAd';
  var MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
  var META_SOURCE = /^(facebook|fb|instagram|ig|meta|an|messenger)$/i;

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage blocked */ }
  }

  // Ad info from this visit's link, or the last Meta visit within 7 days.
  var params = new URLSearchParams(window.location.search);
  var fromLink = {};
  AD_KEYS.forEach(function (k) {
    var v = params.get(k);
    if (v) fromLink[k] = k === 'fbclid' ? v.slice(0, 40) : v.slice(0, 200);
  });
  var linkIsMeta = !!fromLink.fbclid || META_SOURCE.test(fromLink.utm_source || '');
  var ad = null;
  if (linkIsMeta) {
    ad = fromLink;
    ad.first_seen = new Date().toISOString();
    ad.saved_at = Date.now();
    write(STORE_KEY, ad);
  } else {
    var saved = read(STORE_KEY);
    if (saved && saved.saved_at && Date.now() - saved.saved_at < MAX_AGE_MS) ad = saved;
  }

  window.psoAttribution = function () {
    if (!ad) return {};
    var out = {};
    AD_KEYS.forEach(function (k) { if (ad[k]) out[k] = ad[k]; });
    out.landed_at = ad.first_seen || '';
    return out;
  };

  // Not from a Meta ad: no tracking.
  if (!ad) { window.psoTrack = function () {}; return; }

  var anonId = null;
  try { anonId = sessionStorage.getItem('psoAnonId'); } catch (e) { /* storage blocked */ }
  if (!anonId) {
    anonId = 'pso-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    try { sessionStorage.setItem('psoAnonId', anonId); } catch (e) { /* storage blocked */ }
  }

  var startedAt = Date.now();
  var maxDepth = 0;
  var lastSection = 'Top';
  var base = {
    page: window.location.pathname,
    returning_visit: !linkIsMeta,
    device: window.innerWidth < 760 ? 'mobile' : 'desktop',
    utm_source: ad.utm_source || '',
    utm_medium: ad.utm_medium || '',
    utm_campaign: ad.utm_campaign || '',
    utm_content: ad.utm_content || '',
    utm_term: ad.utm_term || '',
    campaign_id: ad.campaign_id || '',
    adset_id: ad.adset_id || '',
    ad_id: ad.ad_id || '',
    placement: ad.placement || '',
    has_fbclid: !!ad.fbclid
  };
  var count = 0;

  function seconds() { return Math.round((Date.now() - startedAt) / 1000); }

  // Klaviyo metric names start with "Sleep Page" so they're easy to find and report on.
  window.psoTrack = function (metric, props, pixelEvent) {
    count += 1;
    var properties = Object.assign({}, base, { seconds_on_page: seconds(), max_depth: maxDepth, headline_version: window.psoHeadline || 'Main' }, props || {});
    if (company && window.fetch) {
      try {
        fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-07-15' },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                properties: properties,
                unique_id: anonId + '-' + Date.now().toString(36) + '-' + count,
                time: new Date().toISOString(),
                metric: { data: { type: 'metric', attributes: { name: metric } } },
                profile: { data: { type: 'profile', attributes: { anonymous_id: anonId } } }
              }
            }
          })
        }).catch(function () { /* tracking must never break the page */ });
      } catch (e) { /* tracking must never break the page */ }
    }
    if (pixelEvent && typeof window.fbq === 'function') {
      try { window.fbq('trackCustom', pixelEvent, properties); } catch (e) { /* ignore */ }
    }
  };

  window.psoTrack('Sleep Page Viewed', { referrer: (document.referrer || '').slice(0, 200) });

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn();
  }

  ready(function () {
    // Scroll depth: 25, 50, 75 and 100% of the whole page, each sent once.
    var marks = [25, 50, 75, 100];
    var sent = {};
    var ticking = false;
    function checkDepth() {
      ticking = false;
      var doc = document.documentElement;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      var pct = Math.min(100, Math.round((window.scrollY / max) * 100));
      if (pct > maxDepth) maxDepth = pct;
      marks.forEach(function (m) {
        if (!sent[m] && pct >= (m === 100 ? 98 : m)) {
          sent[m] = true;
          window.psoTrack('Sleep Page Scroll Depth', { depth: m, last_section: lastSection }, 'ScrollDepth');
        }
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(checkDepth); }
    }, { passive: true });

    // Which parts of the article she actually reached, in order (counted when a section crosses the middle of the screen).
    var SECTIONS = [
      ['.pso-symptoms', 'Does this sound familiar'],
      ['.pso-urge', 'Bladder animation'],
      ['.pso-causes', 'Why the usual tricks fail'],
      ['.pso-points', 'Why pumpkin seed oil'],
      ['.pso-journey', 'What to expect'],
      ['.pso-tvideo', 'Barbara video'],
      ['.pso-trust', 'Why women trust Gluca'],
      ['#pso-offer', 'Offer'],
      ['[data-pso-add]', 'Checkout button'],
      ['.pso-reviews', 'Reviews'],
      ['.pso-faq', 'Questions'],
      ['.pso-foot', 'Footer']
    ];
    var order = 0;
    if ('IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          sio.unobserve(e.target);
          order += 1;
          lastSection = e.target.getAttribute('data-pso-track-name');
          window.psoTrack('Sleep Page Section Reached', { section: lastSection, order: order });
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      SECTIONS.forEach(function (pair) {
        var el = document.querySelector(pair[0]);
        if (el) { el.setAttribute('data-pso-track-name', pair[1]); sio.observe(el); }
      });
    }

    // Every button, link and control she taps, with a readable name and where it was.
    function areaOf(el) {
      if (el.closest('.pso-sticky')) return 'Sticky bar';
      if (el.closest('.pso-rail')) return 'Desktop side card';
      if (el.closest('.pso-gallery')) return 'Photo gallery';
      if (el.closest('#pso-offer')) return 'Offer';
      if (el.closest('.pso-reviews')) return 'Reviews';
      if (el.closest('.pso-faq')) return 'Questions';
      if (el.closest('.pso-tvideo')) return 'Barbara video';
      if (el.closest('.pso-foot')) return 'Footer';
      return 'Article';
    }
    function nameOf(el) {
      if (el.matches('[data-pso-add]')) return 'Checkout now';
      if (el.matches('[data-pso-sticky-buy]')) return 'Sticky Checkout now';
      if (el.matches('[data-pso-sticky-link]')) return 'Sticky: ' + el.textContent.trim();
      if (el.matches('[data-pso-gprev]')) return 'Gallery previous';
      if (el.matches('[data-pso-gnext]')) return 'Gallery next';
      if (el.matches('[data-pso-gthumb]')) return 'Gallery photo ' + (Number(el.getAttribute('data-pso-gthumb')) + 1);
      if (el.matches('[data-pso-rprev]')) return 'Reviews previous';
      if (el.matches('[data-pso-rnext]')) return 'Reviews next';
      if (el.matches('[data-pso-tplay]')) return 'Play Barbara video';
      if (el.tagName === 'SUMMARY') return 'Open: ' + el.textContent.trim();
      return (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80) || el.tagName;
    }
    function selectedBundle() {
      var b = document.querySelector('input[name="pso-bundle"]:checked');
      var label = b && b.closest('.pso-bundle');
      var nm = label && label.querySelector('.pso-bundle__name');
      return nm ? nm.textContent.trim() : '';
    }
    function subscribed() {
      var t = document.querySelector('[data-pso-sub]');
      return t ? t.checked : false;
    }

    document.addEventListener('click', function (e) {
      var el = e.target.closest('a, button, summary, [data-pso-gthumb]');
      if (!el || el.closest('.pso-bundle')) return;
      var props = { cta: nameOf(el), area: areaOf(el), href: el.getAttribute('href') || '', depth_at_click: maxDepth };
      if (el.matches('[data-pso-add], [data-pso-sticky-buy]')) {
        props.bundle = selectedBundle();
        props.subscribe = subscribed();
        var price = document.querySelector('[data-pso-btnprice]');
        props.price_shown = price ? price.textContent.replace(/^\s*\|\s*/, '') : '';
      }
      window.psoTrack('Sleep Page CTA Click', props, 'CTAClick');
    }, true);

    // Choices inside the offer.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[name="pso-bundle"]')) {
        window.psoTrack('Sleep Page CTA Click', { cta: 'Bundle: ' + selectedBundle(), area: 'Offer', depth_at_click: maxDepth }, 'CTAClick');
      } else if (t.matches('[data-pso-sub]')) {
        window.psoTrack('Sleep Page CTA Click', { cta: 'Subscribe & save ' + (t.checked ? 'on' : 'off'), area: 'Offer', depth_at_click: maxDepth }, 'CTAClick');
      }
    });

    // When she leaves or switches away: how far she got and for how long.
    var exitSent = false;
    function sendExit() {
      if (exitSent) return;
      exitSent = true;
      window.psoTrack('Sleep Page Exit', { last_section: lastSection });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') sendExit();
      else exitSent = false;
    });
    window.addEventListener('pagehide', sendExit);
  });
})();
